// Polyfill to run parsing functions from `fast-csv` in browser environment
if (!window.setImmediate) {
  (window as any).setImmediate = (callback: any) => {
    setTimeout(callback, 0);
  };
}
